import { ChartCard } from '../ui/ChartCard';
import styles from './style.module.css';

// Time spent per brand (events analytics), busiest first. `time.value` is raw
// seconds — used for the bar width; `time.display` is the formatted hours.
// `avg` (ES only) is the mean time per visit to the brand (time ÷ visits).
type TimeByBrand = {
  brand_id: string;
  name: string;
  time: { value: number; display: string };
  avg?: { value: number; display: string };
};

export function TimeByBrandList({ items }: { items: TimeByBrand[] }) {
  if (!items.length) return null;
  const max = items.reduce((m, b) => Math.max(m, b.time.value), 0) || 1;
  const hasAvg = items.some((b) => b.avg);
  return (
    <ChartCard title="Time per brand">
      <ul className={styles.list}>
        {items.map((b) => (
          <li key={b.brand_id} className={styles.row}>
            <span className={`${styles.name} mono`}>{b.name}</span>
            <div className={styles.track} aria-hidden>
              <div className={styles.fill} style={{ width: `${(b.time.value / max) * 100}%`, background: 'var(--accent)' }} />
            </div>
            <span className={`${styles.value} mono`}>{b.time.display}</span>
            {hasAvg && <span className={`${styles.avg} mono`}>{b.avg?.display ?? '—'}</span>}
          </li>
        ))}
      </ul>
    </ChartCard>
  );
}
